//https://github.com/redux-utilities/redux-actions
import { createActions, handleActions } from 'redux-actions'

const localStorageKey = 'registerPoint'

const initialState = {
  re: '',
  codCliente: '',
  codUnidade: '',
  name: '',
  nomeCliente: '',
  nomeUnidade: '',
  horarioEntrada: '',
  horarioSaida: '',
  horarioIntervalo: '',
  trocarSenha: '',
  tipo: '',
  toleranciaAntecipacao: '',
  toleranciaAtraso: '',
  endereco: '',
  codigoAssociacao: '',
  coordenadas: false
}
//o reducer começa assim
const defaultState = window.localStorage.getItem(localStorageKey) ? JSON.parse(window.localStorage.getItem(localStorageKey)) : initialState

//tem uma ação para salvar
export const { registerPointReset, registerPointSave } = createActions({
   REGISTER_POINT_RESET: () => ({  }),
   REGISTER_POINT_SAVE: (value) => ({ value })
})


//função de salvar
export const ReduxRegisterPoint = handleActions(
    { 
      [registerPointReset]: (state) => {
        
        window.localStorage.removeItem(localStorageKey)
        return { ...state, re: '',
                name: '',
                codCliente: '',
                codUnidade: '',
                nomeCliente: '',
                nomeUnidade: '',
                horarioEntrada: '',
                horarioSaida: '',
                horarioIntervalo: '',
                trocarSenha: '',
                tipo: '',
                toleranciaAntecipacao: '',
                toleranciaAtraso: '',
                endereco: '', 
                codigoAssociacao: '',
                coordenadas: false 
              }
      },
      [registerPointSave]: (state, { payload: { value } }) => {
        
        window.localStorage.setItem(localStorageKey, JSON.stringify({
                            re: value.re,
                            codCliente: value.codCliente,
                            codUnidade: value.codUnidade,
                            name: value.name,
                            nomeCliente: value.nomeCliente,
                            nomeUnidade: value.nomeUnidade,
                            horarioEntrada: value.horarioEntrada,
                            horarioSaida: value.horarioSaida,
                            horarioIntervalo: value.horarioIntervalo,
                            trocarSenha: value.trocarSenha,
                            tipo: value.tipo,
                            toleranciaAntecipacao: value.toleranciaAntecipacao,
                            toleranciaAtraso: value.toleranciaAtraso,
                            endereco: value.endereco,
                            codigoAssociacao: value.codigoAssociacao,
                            coordenadas: value.coordenadas
                          }))
        
        return { ...state, re: value.re,
            codCliente: value.codCliente,
            codUnidade: value.codUnidade,
            name: value.name,
            nomeCliente: value.nomeCliente,
            nomeUnidade: value.nomeUnidade,
            horarioEntrada: value.horarioEntrada,
            horarioSaida: value.horarioSaida,
            horarioIntervalo: value.horarioIntervalo,
            trocarSenha: value.trocarSenha,
            tipo: value.tipo,
            toleranciaAntecipacao: value.toleranciaAntecipacao,
            toleranciaAtraso: value.toleranciaAtraso,
            endereco: value.endereco,
            coordenadas: value.coordenadas
           }
      }
    },
    defaultState
  )